import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Translation from '../../../services/translation.service';
const SEOContent = ({ title, metas }) => {
  const lang = Translation.getLanguage(window.location.pathname);
  var hreflangValue = 'en-sa';
  if (lang === 'en') {
    hreflangValue = 'en-sa';
  } else {
    hreflangValue = 'ar-sa';
  }
  return (
    <Helmet>
      {title}
      {metas}
      <link rel="canonical" href={window.location.href} />
      <link
        rel="alternate"
        href={window.location.href}
        hreflang={hreflangValue}
      />
    </Helmet>
  );
};
export default withRouter(SEOContent);
